import { IoTServiceException as __BaseException } from "./IoTServiceException";
export var LogTargetType;
(function (LogTargetType) {
    LogTargetType["CLIENT_ID"] = "CLIENT_ID";
    LogTargetType["DEFAULT"] = "DEFAULT";
    LogTargetType["PRINCIPAL_ID"] = "PRINCIPAL_ID";
    LogTargetType["SOURCE_IP"] = "SOURCE_IP";
    LogTargetType["THING_GROUP"] = "THING_GROUP";
})(LogTargetType || (LogTargetType = {}));
export var CertificateMode;
(function (CertificateMode) {
    CertificateMode["DEFAULT"] = "DEFAULT";
    CertificateMode["SNI_ONLY"] = "SNI_ONLY";
})(CertificateMode || (CertificateMode = {}));
export var CACertificateStatus;
(function (CACertificateStatus) {
    CACertificateStatus["ACTIVE"] = "ACTIVE";
    CACertificateStatus["INACTIVE"] = "INACTIVE";
})(CACertificateStatus || (CACertificateStatus = {}));
export var CertificateStatus;
(function (CertificateStatus) {
    CertificateStatus["ACTIVE"] = "ACTIVE";
    CertificateStatus["INACTIVE"] = "INACTIVE";
    CertificateStatus["PENDING_ACTIVATION"] = "PENDING_ACTIVATION";
    CertificateStatus["PENDING_TRANSFER"] = "PENDING_TRANSFER";
    CertificateStatus["REGISTER_INACTIVE"] = "REGISTER_INACTIVE";
    CertificateStatus["REVOKED"] = "REVOKED";
})(CertificateStatus || (CertificateStatus = {}));
export var DetectMitigationActionsTaskStatus;
(function (DetectMitigationActionsTaskStatus) {
    DetectMitigationActionsTaskStatus["CANCELED"] = "CANCELED";
    DetectMitigationActionsTaskStatus["FAILED"] = "FAILED";
    DetectMitigationActionsTaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DetectMitigationActionsTaskStatus["SUCCESSFUL"] = "SUCCESSFUL";
})(DetectMitigationActionsTaskStatus || (DetectMitigationActionsTaskStatus = {}));
export var DomainConfigurationStatus;
(function (DomainConfigurationStatus) {
    DomainConfigurationStatus["DISABLED"] = "DISABLED";
    DomainConfigurationStatus["ENABLED"] = "ENABLED";
})(DomainConfigurationStatus || (DomainConfigurationStatus = {}));
export var DomainType;
(function (DomainType) {
    DomainType["AWS_MANAGED"] = "AWS_MANAGED";
    DomainType["CUSTOMER_MANAGED"] = "CUSTOMER_MANAGED";
    DomainType["ENDPOINT"] = "ENDPOINT";
})(DomainType || (DomainType = {}));
export var ServerCertificateStatus;
(function (ServerCertificateStatus) {
    ServerCertificateStatus["INVALID"] = "INVALID";
    ServerCertificateStatus["VALID"] = "VALID";
})(ServerCertificateStatus || (ServerCertificateStatus = {}));
export var EventType;
(function (EventType) {
    EventType["CA_CERTIFICATE"] = "CA_CERTIFICATE";
    EventType["CERTIFICATE"] = "CERTIFICATE";
    EventType["JOB"] = "JOB";
    EventType["JOB_EXECUTION"] = "JOB_EXECUTION";
    EventType["POLICY"] = "POLICY";
    EventType["THING"] = "THING";
    EventType["THING_GROUP"] = "THING_GROUP";
    EventType["THING_GROUP_HIERARCHY"] = "THING_GROUP_HIERARCHY";
    EventType["THING_GROUP_MEMBERSHIP"] = "THING_GROUP_MEMBERSHIP";
    EventType["THING_TYPE"] = "THING_TYPE";
    EventType["THING_TYPE_ASSOCIATION"] = "THING_TYPE_ASSOCIATION";
})(EventType || (EventType = {}));
export var IndexStatus;
(function (IndexStatus) {
    IndexStatus["ACTIVE"] = "ACTIVE";
    IndexStatus["BUILDING"] = "BUILDING";
    IndexStatus["REBUILDING"] = "REBUILDING";
})(IndexStatus || (IndexStatus = {}));
export var JobStatus;
(function (JobStatus) {
    JobStatus["CANCELED"] = "CANCELED";
    JobStatus["COMPLETED"] = "COMPLETED";
    JobStatus["DELETION_IN_PROGRESS"] = "DELETION_IN_PROGRESS";
    JobStatus["IN_PROGRESS"] = "IN_PROGRESS";
    JobStatus["SCHEDULED"] = "SCHEDULED";
})(JobStatus || (JobStatus = {}));
export var JobExecutionStatus;
(function (JobExecutionStatus) {
    JobExecutionStatus["CANCELED"] = "CANCELED";
    JobExecutionStatus["FAILED"] = "FAILED";
    JobExecutionStatus["IN_PROGRESS"] = "IN_PROGRESS";
    JobExecutionStatus["QUEUED"] = "QUEUED";
    JobExecutionStatus["REJECTED"] = "REJECTED";
    JobExecutionStatus["REMOVED"] = "REMOVED";
    JobExecutionStatus["SUCCEEDED"] = "SUCCEEDED";
    JobExecutionStatus["TIMED_OUT"] = "TIMED_OUT";
})(JobExecutionStatus || (JobExecutionStatus = {}));
export class InternalServerException extends __BaseException {
    constructor(opts) {
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts,
        });
        this.name = "InternalServerException";
        this.$fault = "server";
        Object.setPrototypeOf(this, InternalServerException.prototype);
    }
}
export var MitigationActionType;
(function (MitigationActionType) {
    MitigationActionType["ADD_THINGS_TO_THING_GROUP"] = "ADD_THINGS_TO_THING_GROUP";
    MitigationActionType["ENABLE_IOT_LOGGING"] = "ENABLE_IOT_LOGGING";
    MitigationActionType["PUBLISH_FINDING_TO_SNS"] = "PUBLISH_FINDING_TO_SNS";
    MitigationActionType["REPLACE_DEFAULT_POLICY_VERSION"] = "REPLACE_DEFAULT_POLICY_VERSION";
    MitigationActionType["UPDATE_CA_CERTIFICATE"] = "UPDATE_CA_CERTIFICATE";
    MitigationActionType["UPDATE_DEVICE_CERTIFICATE"] = "UPDATE_DEVICE_CERTIFICATE";
})(MitigationActionType || (MitigationActionType = {}));
export var DynamicGroupStatus;
(function (DynamicGroupStatus) {
    DynamicGroupStatus["ACTIVE"] = "ACTIVE";
    DynamicGroupStatus["BUILDING"] = "BUILDING";
    DynamicGroupStatus["REBUILDING"] = "REBUILDING";
})(DynamicGroupStatus || (DynamicGroupStatus = {}));
export var Status;
(function (Status) {
    Status["Cancelled"] = "Cancelled";
    Status["Cancelling"] = "Cancelling";
    Status["Completed"] = "Completed";
    Status["Failed"] = "Failed";
    Status["InProgress"] = "InProgress";
})(Status || (Status = {}));
export var ModelStatus;
(function (ModelStatus) {
    ModelStatus["ACTIVE"] = "ACTIVE";
    ModelStatus["EXPIRED"] = "EXPIRED";
    ModelStatus["PENDING_BUILD"] = "PENDING_BUILD";
})(ModelStatus || (ModelStatus = {}));
export var FieldType;
(function (FieldType) {
    FieldType["BOOLEAN"] = "Boolean";
    FieldType["NUMBER"] = "Number";
    FieldType["STRING"] = "String";
})(FieldType || (FieldType = {}));
export var ThingGroupIndexingMode;
(function (ThingGroupIndexingMode) {
    ThingGroupIndexingMode["OFF"] = "OFF";
    ThingGroupIndexingMode["ON"] = "ON";
})(ThingGroupIndexingMode || (ThingGroupIndexingMode = {}));
export var DeviceDefenderIndexingMode;
(function (DeviceDefenderIndexingMode) {
    DeviceDefenderIndexingMode["OFF"] = "OFF";
    DeviceDefenderIndexingMode["VIOLATIONS"] = "VIOLATIONS";
})(DeviceDefenderIndexingMode || (DeviceDefenderIndexingMode = {}));
export var NamedShadowIndexingMode;
(function (NamedShadowIndexingMode) {
    NamedShadowIndexingMode["OFF"] = "OFF";
    NamedShadowIndexingMode["ON"] = "ON";
})(NamedShadowIndexingMode || (NamedShadowIndexingMode = {}));
export var ThingConnectivityIndexingMode;
(function (ThingConnectivityIndexingMode) {
    ThingConnectivityIndexingMode["OFF"] = "OFF";
    ThingConnectivityIndexingMode["STATUS"] = "STATUS";
})(ThingConnectivityIndexingMode || (ThingConnectivityIndexingMode = {}));
export var ThingIndexingMode;
(function (ThingIndexingMode) {
    ThingIndexingMode["OFF"] = "OFF";
    ThingIndexingMode["REGISTRY"] = "REGISTRY";
    ThingIndexingMode["REGISTRY_AND_SHADOW"] = "REGISTRY_AND_SHADOW";
})(ThingIndexingMode || (ThingIndexingMode = {}));
export class NotConfiguredException extends __BaseException {
    constructor(opts) {
        super({
            name: "NotConfiguredException",
            $fault: "client",
            ...opts,
        });
        this.name = "NotConfiguredException";
        this.$fault = "client";
        Object.setPrototypeOf(this, NotConfiguredException.prototype);
    }
}
export var BehaviorCriteriaType;
(function (BehaviorCriteriaType) {
    BehaviorCriteriaType["MACHINE_LEARNING"] = "MACHINE_LEARNING";
    BehaviorCriteriaType["STATIC"] = "STATIC";
    BehaviorCriteriaType["STATISTICAL"] = "STATISTICAL";
})(BehaviorCriteriaType || (BehaviorCriteriaType = {}));
export var DetectMitigationActionExecutionStatus;
(function (DetectMitigationActionExecutionStatus) {
    DetectMitigationActionExecutionStatus["FAILED"] = "FAILED";
    DetectMitigationActionExecutionStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DetectMitigationActionExecutionStatus["SKIPPED"] = "SKIPPED";
    DetectMitigationActionExecutionStatus["SUCCESSFUL"] = "SUCCESSFUL";
})(DetectMitigationActionExecutionStatus || (DetectMitigationActionExecutionStatus = {}));
export const DeletePolicyVersionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteProvisioningTemplateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteProvisioningTemplateResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteProvisioningTemplateVersionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteProvisioningTemplateVersionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteRegistrationCodeRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteRegistrationCodeResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteRoleAliasRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteRoleAliasResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteScheduledAuditRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteScheduledAuditResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteSecurityProfileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteSecurityProfileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteStreamRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteStreamResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteThingRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteThingResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteThingGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteThingGroupResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteThingTypeRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteThingTypeResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteTopicRuleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteTopicRuleDestinationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteTopicRuleDestinationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteV2LoggingLevelRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeprecateThingTypeRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeprecateThingTypeResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeAccountAuditConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeAccountAuditConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeAuditFindingRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeAuditFindingResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeAuditMitigationActionsTaskRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MitigationActionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeAuditMitigationActionsTaskResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeAuditSuppressionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeAuditSuppressionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeAuditTaskRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TaskStatisticsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeAuditTaskResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeAuthorizerRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeAuthorizerResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeBillingGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BillingGroupMetadataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeBillingGroupResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeCACertificateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CertificateValidityFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CACertificateDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RegistrationConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeCACertificateResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeCertificateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TransferDataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CertificateDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeCertificateResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeCustomMetricRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeCustomMetricResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeDefaultAuthorizerRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeDefaultAuthorizerResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeDetectMitigationActionsTaskRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetectMitigationActionsTaskTargetFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetectMitigationActionsTaskStatisticsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ViolationEventOccurrenceRangeFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetectMitigationActionsTaskSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeDetectMitigationActionsTaskResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeDimensionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeDimensionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeDomainConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ServerCertificateSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeDomainConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeEndpointRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeEndpointResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeEventConfigurationsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeEventConfigurationsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeFleetMetricRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeFleetMetricResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeIndexRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeIndexResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeJobRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const JobProcessDetailsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ScheduledJobRolloutFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const JobFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeJobResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeJobExecutionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const JobExecutionStatusDetailsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const JobExecutionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeJobExecutionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeJobTemplateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeJobTemplateResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeManagedJobTemplateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DocumentParameterFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeManagedJobTemplateResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeMitigationActionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeMitigationActionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeProvisioningTemplateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeProvisioningTemplateResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeProvisioningTemplateVersionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeProvisioningTemplateVersionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeRoleAliasRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RoleAliasDescriptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeRoleAliasResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeScheduledAuditRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeScheduledAuditResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeSecurityProfileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeSecurityProfileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeStreamRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StreamInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeStreamResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeThingRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeThingResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeThingGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GroupNameAndArnFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ThingGroupMetadataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeThingGroupResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeThingRegistrationTaskRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeThingRegistrationTaskResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeThingTypeRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ThingTypeMetadataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DescribeThingTypeResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetachPolicyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetachPrincipalPolicyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetachSecurityProfileRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetachSecurityProfileResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetachThingPrincipalRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetachThingPrincipalResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DisableTopicRuleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EnableTopicRuleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetBehaviorModelTrainingSummariesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BehaviorModelTrainingSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetBehaviorModelTrainingSummariesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TermsAggregationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BucketsAggregationTypeFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetBucketsAggregationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BucketFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetBucketsAggregationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetCardinalityRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetCardinalityResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetEffectivePoliciesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EffectivePolicyFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetEffectivePoliciesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetIndexingConfigurationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const FieldFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ThingGroupIndexingConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const IndexingFilterFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ThingIndexingConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetIndexingConfigurationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetJobDocumentRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetJobDocumentResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetLoggingOptionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetLoggingOptionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetOTAUpdateRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ErrorInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const OTAUpdateInfoFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetOTAUpdateResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetPercentilesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PercentPairFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetPercentilesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetPolicyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetPolicyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetPolicyVersionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetPolicyVersionResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetRegistrationCodeRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetRegistrationCodeResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetStatisticsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const StatisticsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetStatisticsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetTopicRuleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TopicRuleFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetTopicRuleResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetTopicRuleDestinationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetTopicRuleDestinationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetV2LoggingOptionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetV2LoggingOptionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListActiveViolationsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListActiveViolationsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAttachedPoliciesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAttachedPoliciesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAuditFindingsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAuditFindingsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAuditMitigationActionsExecutionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAuditMitigationActionsExecutionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAuditMitigationActionsTasksRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAuditMitigationActionsTasksResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAuditSuppressionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAuditSuppressionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAuditTasksRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAuditTasksResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAuthorizersRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListAuthorizersResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListBillingGroupsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListBillingGroupsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListCACertificatesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CACertificateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListCACertificatesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListCertificatesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CertificateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListCertificatesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListCertificatesByCARequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListCertificatesByCAResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListCustomMetricsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListCustomMetricsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListDetectMitigationActionsExecutionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DetectMitigationActionExecutionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListDetectMitigationActionsExecutionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListDetectMitigationActionsTasksRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListDetectMitigationActionsTasksResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListDimensionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListDimensionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListDomainConfigurationsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DomainConfigurationSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListDomainConfigurationsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListFleetMetricsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const FleetMetricNameAndArnFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListFleetMetricsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListIndicesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListIndicesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListJobExecutionsForJobRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const JobExecutionSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const JobExecutionSummaryForJobFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListJobExecutionsForJobResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListJobExecutionsForThingRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const JobExecutionSummaryForThingFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListJobExecutionsForThingResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListJobsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const JobSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListJobsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListJobTemplatesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const JobTemplateSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListJobTemplatesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListManagedJobTemplatesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ManagedJobTemplateSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListManagedJobTemplatesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListMetricValuesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MetricDatumFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListMetricValuesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListMitigationActionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MitigationActionIdentifierFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListMitigationActionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListOTAUpdatesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const OTAUpdateSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListOTAUpdatesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListOutgoingCertificatesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const OutgoingCertificateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListOutgoingCertificatesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListPoliciesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListPoliciesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListPolicyPrincipalsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListPolicyPrincipalsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListPolicyVersionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PolicyVersionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListPolicyVersionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListPrincipalPoliciesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListPrincipalPoliciesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListPrincipalThingsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListPrincipalThingsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListProvisioningTemplatesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ProvisioningTemplateSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListProvisioningTemplatesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListProvisioningTemplateVersionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ProvisioningTemplateVersionSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListProvisioningTemplateVersionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListRelatedResourcesForAuditFindingRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListRelatedResourcesForAuditFindingResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListRoleAliasesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListRoleAliasesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListScheduledAuditsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ScheduledAuditMetadataFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListScheduledAuditsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListSecurityProfilesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SecurityProfileIdentifierFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListSecurityProfilesResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListSecurityProfilesForTargetRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SecurityProfileTargetFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SecurityProfileTargetMappingFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListSecurityProfilesForTargetResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
